import { render, staticRenderFns } from "./addNewDevices.vue?vue&type=template&id=f4c6ec20&"
import script from "./addNewDevices.vue?vue&type=script&lang=js&"
export * from "./addNewDevices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports